import React from 'react';
import Icon from '../../../components/AppIcon';
import amberLogo from '../../../../assets/images/PICL logo.jpg.jpeg';

const FormHeader = ({ currentStep, totalSteps, regularizationMode }) => {
  return (
    <div className="bg-white border-b border-border shadow-sm">
      <div className="max-w-4xl mx-auto px-6 py-8">
        {/* Company Branding */}
        <div className="flex flex-col items-center justify-center mb-8">
          <div className="w-28 h-28 flex items-center justify-center mb-4">
            <img 
              src={amberLogo} 
              alt="PICLEnterprises Logo" 
              className="w-full h-full object-contain"
            />
          </div>
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground">
              {regularizationMode 
                ? 'Update Vendor Information'
                : 'PICL'
              }
            </h1>
            <p className="text-sm text-text-secondary">
              {regularizationMode
                ? 'Review and update your information. Changes will be reviewed by the administrator.'
                : 'Vendor Registration Portal'
              }
            </p>
          </div>
        </div>

        {/* Progress Indicator */}
        <div className="flex items-center justify-center space-x-2 mb-6">
          {Array.from({ length: totalSteps }, (_, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;
            
            return (
              <React.Fragment key={stepNumber}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-micro ${
                  isActive 
                    ? 'bg-primary text-primary-foreground' 
                    : isCompleted 
                      ? 'bg-success text-success-foreground'
                      : 'bg-muted text-text-secondary'
                }`}>
                  {isCompleted ? (
                    <Icon name="Check" size={16} />
                  ) : (
                    stepNumber
                  )}
                </div>
                {stepNumber < totalSteps && (
                  <div className={`w-8 h-0.5 transition-micro ${
                    isCompleted ? 'bg-success' : 'bg-border'
                  }`} />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Step Labels */}
        {(() => {
          const labels = totalSteps === 5
            ? ['Company Info', 'Address Details', 'Bank Info', 'Categorization', 'Agreements']
            : ['Company Info', 'Address Details', 'Bank Info', 'Categorization', 'Compliance', 'Agreements'];
          return (
            <div className="flex justify-between text-xs text-text-secondary">
              {labels.map((label, idx) => (
                <div key={label} className={currentStep === idx + 1 ? 'text-primary font-medium' : ''}>
                  {label}
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default FormHeader;